function showTab(ind, triggerEl) {
  const root = triggerEl ? triggerEl.closest('.product_tabs') : document;
  const sidebarButtons = root.querySelectorAll('.product_tabs_sidebar .sidebar_button');
  const tabContents = root.querySelectorAll('.product_tabs_contents .product_tabs_content');

  sidebarButtons.forEach(button => button.classList.remove('active'));
  tabContents.forEach(tab => tab.classList.remove('active'));

  const activeButton = root.querySelector(`.product_tabs_sidebar .sidebar_button.tab__${ind}`);
  const activeTab = root.querySelector(`.product_tabs_contents .product_tabs_content__${ind}`);
  
  if (activeButton) activeButton.classList.add('active');
  if (activeTab) activeTab.classList.add('active');

  if (window.matchMedia("(max-width: 768px)").matches && activeTab) {
    activeTab.scrollIntoView({ block: 'start' });
  }
}
